import * as React from 'react';

const SvgMaximize = (props) => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Huge-icon/arrows/outline/maximize">
      <path
        id="Vector 351"
        d="M13.125 6.125L13.125 2.375M13.125 2.375L9.375 2.375M13.125 2.375L6.25 9.25"
        stroke="#E31B54"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 352"
        d="M7.5 3.625H4.375C2.99429 3.625 1.875 4.74429 1.875 6.125V11.125C1.875 12.5057 2.99429 13.625 4.375 13.625H9.375C10.7557 13.625 11.875 12.5057 11.875 11.125V8"
        stroke="#E31B54"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgMaximize;
